import RequestService from './request-service';

/**
 * Get all available bet builder tabs,markets and outcomes from Swish for given match Id
 */
export default class SwishMatchDetailsService extends RequestService {
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.swish;
    this.method = 'get';
    this.getParams = {
      matchId: null, // The ID of the match to return markets for
      culture: APP_SETTINGS.player.language, // Language to apply translations for. Can be blank for no translations
    };
  }
}